import { render, staticRenderFns } from "./CopiedBtn.vue?vue&type=template&id=fef153be&scoped=true"
import script from "./CopiedBtn.vue?vue&type=script&lang=js"
export * from "./CopiedBtn.vue?vue&type=script&lang=js"
import style0 from "./CopiedBtn.vue?vue&type=style&index=0&id=fef153be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef153be",
  null
  
)

export default component.exports